import {
  addNavMenuItem,
  addActionBarItem,
  registerBulkAction,
  registerFormInputComponent,
  registerPageTab,
  PageLocationId,
} from "@bb-vendure/admin-ui/core";
import { map, switchMap, isEmpty } from "rxjs/operators";
import {
  registerDataTableComponent,
  registerCustomDetailComponent,
} from "@bb-vendure/admin-ui/core";
import { bulkRemove } from "./components/FanClub/Home/BulkAction";
import { CooperatePanel } from "./components/CustomerClassification/CooperatePanelCustomerPage/panel.component";
import { deleteBulkAction } from "./components/event/Home/bulkAction";
import { bulkRemoveLinks } from "./components/FanClubLink/LinkTable/bulk-action";
import { StockQuantitiesComponent } from "./components/StockQuantities/stock-quantites.component";
import { CountryShippingMethodListComponent } from "./components/country-shipping-method-list/country-shipping-method-list.component";
import { ProductEventSectionComponent } from "./components/product-event-section/product-event-section.component";
import EventToggleComponent from "./components/toggle/event-toggle.component";
import PreorderToggleComponent from "./components/toggle/preorder-toggle.component";
import { deleteDefaultEventConsentBulkAction } from "./components/default-event-consent-content/table/bulkAction";
import { deleteConsentTranslations } from "./components/default-event-consent-content/translation-table/bulkAction";
import { bulkRemoveFanClubAdmin } from "./components/FanClub/ng/fan-club-group-table/BulkAction";
import { bulkRemoveFanClubMember } from "./components/FanClub/ng/fan-club-member-table/BulkAction";
import { EntrantInfoComponent } from "./components/entrant-info/entrant-info.component";
import { FanClubPage } from "./components/FanClub/Home/page.component";
import { FanClubSubmissionList } from "./components/fan-club-submission/fan-club-submission-list.component";
import EventEmailTemplateListComponent from "./components/event-email-template/list/event-email-template-list.component";
import { eventEmailTemplateBulkAction } from "./components/event-email-template/list/BulkAction";

export default [
  registerPageTab({
      location: 'fan-club-list' as PageLocationId,
      tab: 'Fan Clubs',
      route: '/extensions/clubs',
      component: FanClubPage,
  }),
  registerPageTab({
      location: 'fan-club-list' as PageLocationId,
      tab: 'Fan Club Submissions',
      route: '/extensions/clubs/submissions',
      component: FanClubSubmissionList,
  }),
  //Fan Club Bulk Remove
  registerFormInputComponent("preorder-toggle-input", PreorderToggleComponent),
  registerFormInputComponent("event-toggle-input", EventToggleComponent),
  registerBulkAction(bulkRemove),
  registerBulkAction(deleteBulkAction),
  registerBulkAction(bulkRemoveLinks),
  registerBulkAction(deleteConsentTranslations),
  registerPageTab({
    location: "notification-template-list" as PageLocationId,
    tab: "nav.event-email-templates",
    route: "/extensions/event-email-templates",
    tabIcon: "envelope",
    component: EventEmailTemplateListComponent,
  }),
  // addNavMenuItem(
  //   {
  //     id: "event-email-templates",
  //     label: "Event email templates",
  //     routerLink: ["/extensions/event-email-templates"],
  //     requiresPermission: "__disable__",
  //   },
  //   "notifications"
  // ),
  addNavMenuItem(
    {
      id: "customers",
      label: "Customers",
      routerLink: ["/customer", "customers"],
      requiresPermission: "__disable__",
    },
    "customers"
  ),

  addNavMenuItem(
    {
      id: "collections",
      label: "collections",
      routerLink: ["/catalog", "collections"],
      requiresPermission: "__disable__",
    },
    "catalog"
  ),

  addNavMenuItem(
    {
      id: "customer-groups",
      label: "Customer groups",
      routerLink: ["/customer", "groups"],
      requiresPermission: "__disable__",
    },
    "customers"
  ),

  addNavMenuItem(
    {
      id: "general-members",
      label: "nav.general-members",
      icon: "users",
      routerLink: ["/extensions/cus/general"],
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadCustomer");
      },
    },
    "sales"
  ),

  addNavMenuItem(
    {
      id: "cooperate-members",
      label: "nav.cooperate-members",
      icon: "users",
      routerLink: ["/extensions/ui-cooperate"],
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadCustomer");
      },
    },
    "sales"
  ),

  addNavMenuItem(
    {
      id: "fan-club",
      label: "nav.fan-clubs",
      routerLink: ["/extensions/clubs"],
      icon: "users",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadFanClub");
      },
    },
    "sales"
  ),

  addNavMenuItem(
    {
      id: "fan-club-link",
      label: "nav.links",
      routerLink: ["/extensions/links"],
      icon: "link",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadFanClubLink");
      },
    },
    "sales"
  ),
  // Event Management UI
  // addNavMenuItem(
  //   {
  //     id: "event",
  //     label: "nav.events",
  //     routerLink: ["/extensions/event"],
  //     icon: "event",
  //     requiresPermission: (userPermissions) => {
  //       return userPermissions.includes("ReadEvent");
  //     },
  //   },
  //   "event-section"
  // ),
  // registerReactCustomDetailComponent({
  //   locationId: "product-detail",
  //   component: TotalLinksStatisticSection,
  // }),

  addActionBarItem({
    id: "generate-link",
    label: "link.generate-link",
    locationId: "product-detail",
    buttonColor: "primary",
    icon: "link",
    routerLink: (route) => {
      const id = route.snapshot.params.id;
      return ["/extensions/links/generate", id];
    },
    buttonState: (context) => {
      return context.entity$.pipe(
        map((res) => {
          let visible = false;

          if (res) {
            //console.log("generate", res);

            if (res.customFields.isCorporate || res.customFields.freeGifts) {
              visible = false;
            } else {
              visible = true;
            }
          }

          return {
            disabled: false,
            visible,
          };
        })
      );
    },
  }),

  registerCustomDetailComponent({
    locationId: "customer-detail",
    component: CooperatePanel,
  }),

  registerDataTableComponent({
    component: StockQuantitiesComponent,
    tableId: "product-list",
    columnId: "totalStocks",
  }),
  registerFormInputComponent(
    "country-shipping-method",
    CountryShippingMethodListComponent
  ),

  //registerFormInputComponent('product-event-section',ProductEventSectionComponent),

  registerCustomDetailComponent({
    locationId: "product-detail",
    component: ProductEventSectionComponent,
  }),

  // registerCustomDetailComponent({
  //   component : AvailableCountryProductComponent,
  //   locationId : 'product-detail'
  // })

  addNavMenuItem(
    {
      id: "default-event-consent-content",
      label: "nav.event-consent-content",
      routerLink: ["/extensions/event-consent-content"],
      icon: "form",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadEventContentConsent");
      },
    },
    "settings"
  ),
  registerBulkAction(deleteDefaultEventConsentBulkAction),
  registerBulkAction(bulkRemoveFanClubAdmin),
  registerBulkAction(bulkRemoveFanClubMember),

  registerCustomDetailComponent({
    locationId: "order-detail",
    component: EntrantInfoComponent,
  }),

  registerBulkAction(eventEmailTemplateBulkAction),
];
